const Point = () => {
  return (
    <svg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.13478 13.8C7.13478 13.8 12.7696 9.34782 12.7696 6.00869C12.7696 3.24247 10.2468 1 7.13478 1C4.02278 1 1.5 3.24247 1.5 6.00869C1.5 9.34782 7.13478 13.8 7.13478 13.8Z'
        stroke='#6B6B6B'
        strokeWidth='1.2'
      />
      <path
        d='M8.93501 5.8001C8.93501 6.68376 8.12913 7.4001 7.13501 7.4001C6.1409 7.4001 5.33501 6.68376 5.33501 5.8001C5.33501 4.91645 6.1409 4.2001 7.13501 4.2001C8.12913 4.2001 8.93501 4.91645 8.93501 5.8001Z'
        stroke='#6B6B6B'
        strokeWidth='1.2'
      />
    </svg>
  );
};

export default Point;
